import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL
await msalInstance.initialize();

export const loginRequest = {
    scopes: [
        "openid",
        "profile",
        "https://1stopVATb2c.onmicrosoft.com/8cb8e9eb-9d43-4ef7-8c3d-6c3c15b6d060/api.access.user",
    ]
};

export async function getAccessToken() {
    const accounts = msalInstance.getAllAccounts();

    console.log("accounts", accounts);
    if (accounts.length === 0) {
        throw new Error('No active account! Please sign in first.');
    }

    try {
        const response = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0]
        });
        console.log("response", response);
        return response.accessToken;
    } catch (error) {
        const response = await msalInstance.acquireTokenPopup(loginRequest);
        return response.accessToken;
    }
} 